import { useCallback } from 'react';

import { Address } from 'viem';

import { useActiveVoteFarm } from '@services/api/voting/common.api';

import { useAuth } from '@contexts/common/AuthorizationContext';

import { useSignMessage } from '@hooks/common/useSignMessage';

export const useActiveVoteFarmAction = () => {
  const { account } = useAuth();
  const { signData } = useSignMessage();

  const { mutateAsync, isPending } = useActiveVoteFarm();

  const activateVote = useCallback(
    async (id: number) => {
      try {
        if (!account) return;
        const data = {
          timestamp: Date.now(),
          account: account.toLowerCase() as Address,
        };

        const signature = await signData(data);
        if (!signature) return;

        await mutateAsync({
          params: { data, signature },
          id,
        });
      } catch (e) {
        console.error('useVoteAction', e);
      }
    },
    [account, mutateAsync, signData],
  );

  return {
    activateVote,
    isPending,
  };
};
